(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-recommendations"] && !Shopify.designMode) return;
  try {
    class ProductListRecommendations extends HTMLElement {
    static observedAttributes = ['data-url'];

    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      this.load(url);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-url' && newValue && newValue !== oldValue) {
        this.#showShimmer(newValue);
        this.load(newValue);
      }
    }

    #showShimmer(url) {
      const limit = new URL(url, location.origin).searchParams.get('limit') || 4;
      let grid = this.querySelector('.product-list__grid');
      if (!grid) {
        grid = document.createElement('ul');
        grid.className = 'product-list__grid';
        grid.setAttribute('role', 'list');
        this.append(grid);
      }
      grid.setAttribute('aria-busy', 'true');
      grid.innerHTML = '<li><div class="product-list__shimmer"></div></li>'.repeat(limit);
    }

    async load(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.remove();
          return;
        }

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('product-list-recommendations');

        if (source) {
          this.replaceChildren(...source.childNodes);
        } else {
          this.remove();
        }
      } catch {
        this.remove();
      }
    }
  }

  if (!customElements.get('product-list-recommendations')) {
    customElements.define('product-list-recommendations', ProductListRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-list"] && !Shopify.designMode) return;
  try {
    class ProductListRecommendations extends HTMLElement {
    static observedAttributes = ['data-url'];

    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      this.load(url);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-url' && newValue && newValue !== oldValue) {
        this.load(newValue);
      }
    }

    async load(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.remove();
          return;
        }

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('product-list-recommendations');

        if (source) {
          this.replaceChildren(...source.childNodes);
        } else {
          this.remove();
        }
      } catch {
        this.remove();
      }
    }
  }

  if (!customElements.get('product-list-recommendations')) {
    customElements.define('product-list-recommendations', ProductListRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rating"] && !Shopify.designMode) return;
  try {
    // The color swap morphs the buy box, dropping the TrustBox iframe: reload it for the new SKUs.
  document.addEventListener('product:swapped', function () {
    document.querySelectorAll('.rating-block__trustbox').forEach(function (element) {
      if (window.Trustpilot) window.Trustpilot.loadFromElement(element, true);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
